import $ from "jquery";
import plugin from "@core/plugins/lib";

const ELEMENT_SELECTOR = "[data-sync-same-name]";
const PLUGIN_NAME = "syncSameName";

const elements = document.querySelectorAll(ELEMENT_SELECTOR);

elements.forEach((element) => {
	System.import(
		/* webpackChunkName: "sync-same-name" */ "./sync-same-name"
	).then((module) => {
		plugin(PLUGIN_NAME, module.default);
		$(element)[PLUGIN_NAME]();
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/modules/sync-same-name/index--split.js